import { Component, OnInit, ViewChild } from "@angular/core";
import * as FileSaver from "file-saver";
import { NgxSpinnerService } from "ngx-spinner";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { Condition } from "src/app/models/custom-types";
import { AsignacionDTO } from "src/app/models/dto/asignacion.dto";
import { RecepcionDTO } from "src/app/models/dto/entregas.dto";
import { FilterEvent } from "src/app/models/filter";
import { ListAction } from "src/app/models/list-actions.model";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { Filter } from "src/app/shared/classes/filter";
import { LayoutsService } from "../../../services/layouts.service";
import { RecepcionService } from "./entrega.service";
import { EntregaForm } from "./form/form.component";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import * as dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);
@Component({
  selector: "app-entrega",
  templateUrl: "./entrega.component.html",
  styles: [],
})
export class EntregaComponent implements OnInit {
  public columns: ListColumn[] = [
    {
      name: "Chofer",
      property: "Chofer",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Supervisor",
      property: "Supervisor",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Unidad",
      property: "Unidad",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Fecha",
      property: "FechaStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public columnsHi: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Chofer",
      property: "Chofer",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Supervisor",
      property: "Supervisor",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Unidad",
      property: "Unidad",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Fecha",
      property: "FechaStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public actions: ListAction<any>[] = [
    {
      desc: "Completar formulario",
      action: "update",
      visible: () => true,
    },
    {
      desc: "Activar",
      action: "activate",
      visible: (row) => !true,
    },
  ];

  public actionsHi: ListAction<any>[] = [
    {
      desc: "Descargar",
      action: "pdf",
      visible: () => true,
    },
  ];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  @ViewChild("tblHistorico", { static: true })
  public tableCompHistorico: CardTableComponent;

  @ViewChild(EntregaForm, { static: true })
  public formulario: EntregaForm;
  realdataEntregas: AsignacionDTO[];
  realdataHistorico: RecepcionDTO[];

  constructor(
    public service: RecepcionService,
    public spinner: NgxSpinnerService,
    public layoutServ: LayoutsService,
    public alerts: AlertasSwalService
  ) {
    this.layoutServ.changeHeader("Recepcion de unidades");
  }

  ngOnInit(): void {
    this.loadRecords();
    this.filter = new Filter<AsignacionDTO>(
      this.conditions,
      this.columns,
      true
    );
    this.filterHi = new Filter<RecepcionDTO>(
      this.conditionsHi,
      this.columns,
      true
    );
  }
  loadRecords() {
    this.service.getEntrega().subscribe(
      (resultData) => {
        this.realdataEntregas = resultData.map((m) => {
            const date = dayjs.utc(m.Fecha);
            const gmt8Date = date.tz("America/Los_Angeles");
            const fechaTransform = m.Fecha ? gmt8Date : null;
            return {
              ...m,
              FechaStr: fechaTransform
                ? fechaTransform.format("DD/MM/YYYY hh:mm a")
                : "",
            };
        });
        this.filter.setDataTable(this.realdataEntregas, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
    this.service.getEntregaHis().subscribe(
      (resultData) => {
           this.realdataHistorico = resultData.map((m) => {
            const date = dayjs.utc(m.Fecha);
            const gmt8Date = date.tz("America/Los_Angeles");
            const fechaTransform = m.Fecha ? gmt8Date : null;
            return {
              ...m,
              FechaStr: fechaTransform
                ? fechaTransform.format("DD/MM/YYYY hh:mm a")
                : "",
            };
        });
        this.filterHi.setDataTable(
          this.realdataHistorico,
          this.tableCompHistorico
        );
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<AsignacionDTO>;
  public conditions: Condition<AsignacionDTO> = {
    Chofer: (o, f) => o.Chofer.toLocaleLowerCase().indexOf(f) > -1,
    Supervisor: (o, f) => o.Supervisor.toLocaleLowerCase().indexOf(f) > -1,
    Unidad: (o, f) => o.Unidad.toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdataEntregas, this.tableComp);
  }

  public filterHi: Filter<RecepcionDTO>;
  public conditionsHi: Condition<RecepcionDTO> = {
    Chofer: (o, f) => o.Chofer.toLocaleLowerCase().indexOf(f) > -1,
    Supervisor: (o, f) => o.Supervisor.toLocaleLowerCase().indexOf(f) > -1,
    Unidad: (o, f) => o.Unidad.toLocaleLowerCase().indexOf(f) > -1,
    Folio: (o, f) =>
      (o.Folio ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdataHi(e: FilterEvent) {
    this.filterHi.filterdata(
      e,
      this.realdataHistorico,
      this.tableCompHistorico
    );
  }
  //#endregion Filter

  actionstable(e: { action: string; row: any }) {
    if (e.action == "update") {
      this.formulario.setUpdate(e.row);
    } else if (e.action == "pdf") {
      this.downLoad(e.row.IdRecepcion, e.row.Folio);
    }
  }

  downLoad(e, folio) {
    this.spinner.show();
    this.service.getPdf(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "entrega_" + folio + ".pdf"
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }

  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }
}
